/* Tipsy: пиллсы объёмной скидки на PDP.
   Подсветка активного порога + предпросмотр цены со скидкой.
   Реальную скидку считает Shopify Function (tipsy-volume-discount) в корзине —
   здесь только отображение. Пороги/проценты приходят из data-атрибутов сниппета
   tipsy-qty-discount.liquid. */
(() => {
  function init(root) {
    const sectionId = root.dataset.section;
    const input = document.getElementById('Quantity-' + sectionId);
    if (!input) return;
    const priceEl = document.querySelector('#price-' + sectionId + ' .price');
    const originalPriceNodes = priceEl ? Array.from(priceEl.childNodes) : [];

    function buildPreview(original, discounted) {
      const regular = document.createElement('div');
      regular.className = 'price__regular';
      regular.textContent = original;
      const item = document.createElement('div');
      item.className = 'price__item price__sale h4';
      item.textContent = discounted;
      const container = document.createElement('div');
      container.className = 'price__container';
      container.appendChild(item);
      return [regular, container];
    }

    const pills = Array.from(root.querySelectorAll('.tipsy-qty-discount__pill'));
    const tiers = pills
      .filter((p) => p.classList.contains('tipsy-qty-discount__pill--enabled'))
      .map((p) => ({
        threshold: parseInt(p.dataset.threshold, 10),
        percent: parseInt(p.dataset.percent, 10),
        el: p,
      }))
      .sort((a, b) => b.threshold - a.threshold);

    const activeTier = (qty) => tiers.find((t) => qty >= t.threshold) || null;

    function update() {
      const qty = parseInt(input.value, 10) || 0;
      const tier = activeTier(qty);
      pills.forEach((p) => {
        p.classList.toggle('tipsy-qty-discount__pill--active', !!tier && p === tier.el);
      });
      if (!priceEl) return;
      if (tier) {
        const discounted = root.getAttribute('data-price-' + tier.percent);
        const original = root.getAttribute('data-price-orig');
        priceEl.replaceChildren(...buildPreview(original, discounted));
      } else {
        priceEl.replaceChildren(...originalPriceNodes);
      }
    }

    const setQty = (value) => {
      input.value = value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };

    pills.forEach((p) => {
      if (!p.classList.contains('tipsy-qty-discount__pill--enabled')) return;
      p.addEventListener('click', () => {
        // повторный клик по активному пиллу сбрасывает количество
        if (p.classList.contains('tipsy-qty-discount__pill--active')) {
          setQty(1);
        } else {
          setQty(p.dataset.threshold);
        }
      });
      const x = p.querySelector('.tipsy-qty-discount__x');
      if (x) {
        x.addEventListener('click', (e) => {
          e.stopPropagation();
          setQty(1);
        });
      }
    });

    input.addEventListener('change', update);
    input.addEventListener('input', update);
    update();
  }

  document.querySelectorAll('[data-tipsy-qty-discount]').forEach(init);
})();
